{
  "kind": {
    "guest": "ゲスト（アカウントなし）",
    "registered": "アカウントあり"
  },
  "columns": {
    "name": "お名前",
    "email": "メール",
    "phone": "電話番号",
    "kind": "アカウント",
    "locale": "言語",
    "tags": "タグ",
    "marketing": "お知らせメール",
    "last_seen": "最終利用",
    "created": "登録日",
    "state": "状態"
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "marketing": {
    "yes": "はい",
    "no": "いいえ"
  },
  "state": {
    "merged": "別のアカウントに統合済み",
    "closed": "閉鎖",
    "open": "有効"
  },
  "filters": {
    "q": "検索",
    "q_placeholder": "お名前、カナ、メール",
    "closed": "閉鎖・統合済みも表示"
  },
  "list": {
    "intro": "買ってくださった方すべて（アカウントあり・ゲスト）。行を押すと注文、ストアクレジット、重複の統合。",
    "intro_limited": "あなたの役割ではお名前と電話番号の下4桁だけ表示されます。"
  },
  "detail": {
    "back": "顧客一覧",
    "load_failed": "顧客を開けませんでした",
    "orders": "注文（Web・店頭）",
    "no_orders": "このメールの注文はまだありません。",
    "orders_hint": "注文はお客様のメールで探しています。",
    "consents": "同意（プライバシー）",
    "no_consents": "同意の記録はありません。",
    "merged_into": "統合先のアカウントを開く",
    "limited": "あなたの役割ではお名前と電話番号の下4桁だけです。詳しくは店長に。",
    "profile": "詳細",
    "email_verified": "メール確認済み",
    "profile_hint": "これらはお客様がWebサイト（マイアカウント）で変更します。"
  },
  "consent": {
    "privacy": "プライバシーポリシー",
    "terms": "利用規約",
    "marketing": "お知らせメール",
    "cross_border": "海外でのデータ保管",
    "accepted": "同意",
    "declined": "不同意"
  },
  "credit": {
    "title": "ストアクレジット",
    "issue": "クレジットを付与",
    "issue_title": "ストアクレジットを付与",
    "issue_description": "最終日まで、お店とWebサイトでお支払いに使えます。",
    "issue_confirm": "付与する",
    "issued": "ストアクレジット {{amount}} を付与しました",
    "issued_hint": "{{day}} まで使えます。",
    "amount": "金額",
    "reason": "理由",
    "reason_placeholder": "例：発送遅れのお詫び",
    "kind": "お客様は対価を払っていますか？",
    "paid_for": "はい — お金の代わり（返金、買取）",
    "free": "いいえ — お店からのプレゼント",
    "last_day": "最終日",
    "last_day_hint": "最長 {{day}} まで：それより長いと資金決済法の対象になります。",
    "blocker": {
      "amount": "金額を円（整数）で入れてください。",
      "reason": "理由を書いてください。",
      "day_after_max": "ストアクレジットは最長 6 か月です — {{day}} 以前を選んでください（資金決済法）。",
      "day_past": "最終日は過去にできません。",
      "day_invalid": "日付を選んでください。"
    },
    "load_failed": "ストアクレジットを読み込めませんでした",
    "paid_for_balance": "対価あり：",
    "free_balance": "プレゼント：",
    "next_expiry": "次に終わる分：",
    "lots": "付与したクレジット",
    "col": {
      "given": "付与日",
      "amount": "金額",
      "left": "残り",
      "last_day": "最終日",
      "reason": "理由"
    },
    "expired": "終了",
    "paid_for_short": "対価あり",
    "free_short": "プレゼント",
    "none": "ストアクレジットはまだありません。",
    "history": "履歴",
    "entry": {
      "issue": "付与",
      "redeem": "利用",
      "expire": "期限切れ",
      "refund_in": "返金から戻し",
      "adjust": "訂正",
      "reverse": "取り消し"
    },
    "law": "ストアクレジットは最長 6 か月（資金決済法）で、現金での払い戻しはできません。"
  },
  "merge": {
    "open": "重複を統合",
    "title": "同じ人の 2 つのアカウントを統合",
    "description": "もう一方のアカウントを探し、残す方を選び、どうなるか確認してから確定します。",
    "search": "もう一方のアカウントを探す",
    "search_hint": "お名前かメール。",
    "which": "同じ人のアカウントはどれ？",
    "none": "ほかのアカウントは見つかりません。",
    "choose": "先にもう一方のアカウントを選んでください。",
    "stays": "どちらを残しますか？",
    "keep": "残す",
    "close": "閉じる",
    "next": "確認して統合",
    "effect_addresses": "住所とログインは {{name}} に移ります。",
    "effect_closed": "{{email}} は閉じられます。",
    "effect_search": "あとで {{email}} を検索すると {{name}} が見つかります。",
    "effect_orders": "注文のお客様情報はそのままです。",
    "confirm_title": "このアカウントを統合しますか？",
    "confirm_consequence": "{{close}} は閉じられ、内容は {{keep}} に移ります。元に戻せません。",
    "confirm": "統合する",
    "done": "統合しました — {{name}} を残しました",
    "done_hint": "住所 {{addresses}} 件を移しました。"
  },
  "dsar": {
    "title": "お客様のデータ（個人情報保護法）",
    "body": "お客様からデータのコピーや削除を求められたら、ここで記録します。システムがお店のすべての部分から集めます。",
    "export": "データのコピー",
    "delete": "データの削除",
    "export_title": "このお客様のデータのコピーを作りますか？",
    "export_consequence": "お客様にダウンロードのリンクがメールで届きます。本人確認の方法を書いてください。",
    "delete_title": "このお客様のデータを削除しますか？",
    "delete_consequence": "法律で保存が必要なデータ（領収書、古物台帳）は残ります。本人確認の方法を書いてください。",
    "done_export": "データのコピーを依頼しました",
    "done_delete": "削除を依頼しました",
    "done_hint": "法律の期限内に完了し、お知らせが届きます。"
  }
}
